import { defineMessage, IntlShape, MessageDescriptor } from 'react-intl'

import {
  ServiceProviderCategoryEnum,
  ServiceProvisionActivityTypeEnum,
  ServiceProvisionBatchProvisionTypeEnum,
  ServiceProvisionHouseTypeEnum,
  ServiceProvisionRestaurationTypeEnum,
  ServiceProvisionTransportTypeEnum,
  ServiceProvisionTypeEnum,
} from '../lib/graphql'

const serviceProvisionRestaurationLabels: Record<
  ServiceProvisionRestaurationTypeEnum,
  MessageDescriptor
> = {
  [ServiceProvisionRestaurationTypeEnum.BREAKFAST]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.breakfast',
    defaultMessage: 'Petit déjeuner',
  }),
  [ServiceProvisionRestaurationTypeEnum.LUNCH]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.lunch',
    defaultMessage: 'Déjeuner',
  }),
  [ServiceProvisionRestaurationTypeEnum.DINNER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.dinner',
    defaultMessage: 'Diner',
  }),
  [ServiceProvisionRestaurationTypeEnum.DRINK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.drink',
    defaultMessage: 'Boisson hors des repas',
  }),
  [ServiceProvisionRestaurationTypeEnum.MEAL_DRINK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.mealDrink',
    defaultMessage: 'Boisson repas',
  }),
  [ServiceProvisionRestaurationTypeEnum.PERMANENT_SNACK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.permanentSnack',
    defaultMessage: 'Collation permanente',
  }),
  [ServiceProvisionRestaurationTypeEnum.MORNING_SNACK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.morningSnack',
    defaultMessage: 'Collation matin',
  }),
  [ServiceProvisionRestaurationTypeEnum.AFTERNOON_SNACK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.afternoonSnack',
    defaultMessage: 'Collation après-midi',
  }),
  [ServiceProvisionRestaurationTypeEnum.APERITIF]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.aperitif',
    defaultMessage: 'Apéritif',
  }),
  [ServiceProvisionRestaurationTypeEnum.GROCERY_DELIVERY]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.groceryDelivery',
    defaultMessage: 'Récupération des courses en drive',
  }),
  [ServiceProvisionRestaurationTypeEnum.WELCOME_COFFEE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.welcomeCoffee',
    defaultMessage: "Café d'accueil",
  }),
  [ServiceProvisionRestaurationTypeEnum.OTHER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.other',
    defaultMessage: 'Autre',
  }),
}

const serviceProvisionActivityLabels: Record<
  ServiceProvisionActivityTypeEnum,
  MessageDescriptor
> = {
  [ServiceProvisionActivityTypeEnum.CREATIVE_WORKSHOPS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.creativeWorkshops',
    defaultMessage: 'Ateliers créatifs',
  }),
  [ServiceProvisionActivityTypeEnum.ARCHERY]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.archery',
    defaultMessage: "Tir à l'arc",
  }),
  [ServiceProvisionActivityTypeEnum.BIKE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.bike',
    defaultMessage: 'Vélo',
  }),
  [ServiceProvisionActivityTypeEnum.GAMES_AND_CONSTRUCTION]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.gamesAndConstruction',
    defaultMessage: 'Jeux & Construction',
  }),
  [ServiceProvisionActivityTypeEnum.CASINO_NIGHT]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.casinoNight',
    defaultMessage: 'Soirée casino',
  }),
  [ServiceProvisionActivityTypeEnum.DJ_SOUND_AND_LIGHTING]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.djSoundAndLighting',
    defaultMessage: 'DJ son & lumière',
  }),
  [ServiceProvisionActivityTypeEnum.ESCAPE_GAME]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.escapeGame',
    defaultMessage: 'Escape Game',
  }),
  [ServiceProvisionActivityTypeEnum.EVENT_PROJECT_MANAGER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.eventProjectManager',
    defaultMessage: 'Chef de projet événementiel',
  }),
  [ServiceProvisionActivityTypeEnum.GUESS_THE_SONG_GAME_AND_KARAOKE]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.guessTheSongGameAndKaraoke',
      defaultMessage: 'Blind Test & Karaoke',
    }),
  [ServiceProvisionActivityTypeEnum.MAGIC_AND_MENTALISM]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.magicAndMentalism',
    defaultMessage: 'Magie & Mentalisme',
  }),
  [ServiceProvisionActivityTypeEnum.COOKING_COURSE_AND_MIXOLOGY]: defineMessage(
    {
      id: 'ui.serviceProvisionTypeLabel.cookingCourseAndMixology',
      defaultMessage: 'Cours de cuisine & Mixologie',
    },
  ),
  [ServiceProvisionActivityTypeEnum.MURDER_AND_MYSTERY_PARTY]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.murderAndMysteryParty',
    defaultMessage: 'Enquêtes & Murder Party',
  }),
  [ServiceProvisionActivityTypeEnum.DEGUSTATION]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.degustation',
    defaultMessage: 'Dégustations',
  }),
  [ServiceProvisionActivityTypeEnum.OLYMPIADS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.olympiads',
    defaultMessage: 'Olympiades',
  }),
  [ServiceProvisionActivityTypeEnum.PHOTOGRAPHER_AND_PHOTOBOOTH]: defineMessage(
    {
      id: 'ui.serviceProvisionTypeLabel.photographerAndPhotobooth',
      defaultMessage: 'Photographe & Photobooth',
    },
  ),
  [ServiceProvisionActivityTypeEnum.QUIZ_AND_BURGER_CHALLENGE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.quizAndBurgerChallenge',
    defaultMessage: 'Quiz & Burger Challenge',
  }),
  [ServiceProvisionActivityTypeEnum.CSR_WORKSHOP]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.csrWorkshop',
    defaultMessage: 'Ateliers RSE',
  }),
  [ServiceProvisionActivityTypeEnum.DISCOVERY_WALK]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.discoveryWalk',
    defaultMessage: 'Balades découverte',
  }),
  [ServiceProvisionActivityTypeEnum.TREASURE_HUNT_AND_ORIENTEERING_RACE]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.treasureHuntAndOrienteeringRace',
      defaultMessage: 'Chasse au trésor & Course d’orientation',
    }),
  [ServiceProvisionActivityTypeEnum.YOGA_AND_PILATES]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.yogaAndPilates',
    defaultMessage: 'Yoga & Pilates',
  }),
  [ServiceProvisionActivityTypeEnum.CONFERENCES]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.conferences',
    defaultMessage: 'Conférences',
  }),
  [ServiceProvisionActivityTypeEnum.TREE_CLIMBING]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.treeClimbing',
    defaultMessage: 'Accrobranche',
  }),
  [ServiceProvisionActivityTypeEnum.MOUNTAIN_ACTIVITIES]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.mountainActivities',
    defaultMessage: 'Activités montagne',
  }),
  [ServiceProvisionActivityTypeEnum.NAUTICAL_ACTIVITIES]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.nauticalActivities',
    defaultMessage: 'Activités nautique',
  }),
  [ServiceProvisionActivityTypeEnum.DANCE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.dance',
    defaultMessage: 'Danse',
  }),
  [ServiceProvisionActivityTypeEnum.HORSE_RIDING]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.horseRiding',
    defaultMessage: 'Equitation',
  }),
  [ServiceProvisionActivityTypeEnum.GOODIES]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.goodies',
    defaultMessage: 'Goodies',
  }),
  [ServiceProvisionActivityTypeEnum.MASSAGE_AND_WELLNESS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.massageAndWellness',
    defaultMessage: 'Massage & Bien-être',
  }),
  [ServiceProvisionActivityTypeEnum.PAINTBALL_AND_LASER_TAG]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.paintballAndLaserTag',
    defaultMessage: 'Paintball & Laser Game',
  }),
  [ServiceProvisionActivityTypeEnum.TECHNICAL_PRESTATION]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.technicalPrestation',
    defaultMessage: 'Prestations technique',
  }),
  [ServiceProvisionActivityTypeEnum.MOTORSPORTS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.motorsports',
    defaultMessage: 'Sports mécaniques',
  }),
  [ServiceProvisionActivityTypeEnum.GUIDED_VISITS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.guidedVisits',
    defaultMessage: 'Visite guidées',
  }),
  [ServiceProvisionActivityTypeEnum.OTHER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.other',
    defaultMessage: 'Autre',
  }),
}

const serviceProvisionTransportLabels: Record<
  ServiceProvisionTransportTypeEnum,
  MessageDescriptor
> = {
  [ServiceProvisionTransportTypeEnum.BUS]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.bus',
    defaultMessage: 'Autocar',
  }),
  [ServiceProvisionTransportTypeEnum.OTHER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.other',
    defaultMessage: 'Autre',
  }),
  [ServiceProvisionTransportTypeEnum.PLANE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.plane',
    defaultMessage: 'Avion',
  }),
  [ServiceProvisionTransportTypeEnum.SHUTTLE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.shuttle',
    defaultMessage: 'Navette',
  }),
  [ServiceProvisionTransportTypeEnum.TAXI]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.taxi',
    defaultMessage: 'Taxi',
  }),
  [ServiceProvisionTransportTypeEnum.TRAIN]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.train',
    defaultMessage: 'Train',
  }),
  [ServiceProvisionTransportTypeEnum.VTC]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.vtc',
    defaultMessage: 'VTC',
  }),
}

const serviceProvisionHouseLabels: Record<
  ServiceProvisionHouseTypeEnum,
  MessageDescriptor
> = {
  [ServiceProvisionHouseTypeEnum.SPACE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.space',
    defaultMessage: 'Espace',
  }),
  [ServiceProvisionHouseTypeEnum.STAFF]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.staff',
    defaultMessage: 'Personnel',
  }),
  [ServiceProvisionHouseTypeEnum.MATERIAL]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.material',
    defaultMessage: 'Matériel',
  }),
  [ServiceProvisionHouseTypeEnum.PRIVATIZATION]: defineMessage({
    id: 'Privatisation',
    defaultMessage: 'Privatisation',
  }),
  [ServiceProvisionHouseTypeEnum.EXTRA]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.extra',
    defaultMessage: 'Suppléments',
  }),
  [ServiceProvisionHouseTypeEnum.OTHER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.other',
    defaultMessage: 'Autre',
  }),
}

const serviceProvisionBatchProvisionsLabels: Record<
  ServiceProvisionBatchProvisionTypeEnum,
  MessageDescriptor
> = {
  [ServiceProvisionBatchProvisionTypeEnum.SINGLE_RESIDENTIAL_SEMINAR]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.singleResidentialSeminar',
      defaultMessage: 'Forfait séminaire résidentiel single',
    }),
  [ServiceProvisionBatchProvisionTypeEnum.SHARED_RESIDENTIAL_SEMINAR]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.sharedResidentialSeminar',
      defaultMessage: 'Forfait séminaire résidentiel partagé',
    }),
  [ServiceProvisionBatchProvisionTypeEnum.DAY_PACKAGE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.dayPackage',
    defaultMessage: "Forfait journée d'étude",
  }),
  [ServiceProvisionBatchProvisionTypeEnum.MORNING_HALF_DAY_PACKAGE]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.morningHalfDayPackage',
      defaultMessage: "Forfait 1/2 journée d'étude matin",
    }),
  [ServiceProvisionBatchProvisionTypeEnum.AFTERNOON_HALF_DAY_PACKAGE]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.afternoonHalfDayPackage',
      defaultMessage: "Forfait 1/2 journée d'étude après-midi",
    }),
  [ServiceProvisionBatchProvisionTypeEnum.BNB_SINGLE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.bnbSingle',
    defaultMessage: 'Forfait bed & breakfast single',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.BNB_TWIN]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.bnbTwin',
    defaultMessage: 'Forfait bed & breakfast partagé',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.EVENING_PACKAGE]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.eveningPackage',
    defaultMessage: 'Forfait soirée',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.WORKSPACE_DAY]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.workspaceDay',
    defaultMessage: 'Forfait journée espace de travail',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.WORKSPACE_HALF_DAY]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.workspaceHalfDay',
    defaultMessage: 'Forfait 1/2 journée espace de travail',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.DELIVERY_24_HOURS_RESTORATION_PACKAGE]:
    defineMessage({
      id: 'ui.serviceProvisionTypeLabel.delivery24HoursRestorationPackage',
      defaultMessage: 'Forfait restauration 24h',
    }),
  [ServiceProvisionBatchProvisionTypeEnum.DANCE_EVENING]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.danceEvening',
    defaultMessage: 'Forfait soirée dansante',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.COCKTAIL_RECEPTION]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.cocktailReception',
    defaultMessage: 'Forfait cocktail dînatoire',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.SEATED_DINNER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.seatedDinner',
    defaultMessage: 'Forfait dîner assis',
  }),
  [ServiceProvisionBatchProvisionTypeEnum.OTHER]: defineMessage({
    id: 'ui.serviceProvisionTypeLabel.otherPackage',
    defaultMessage: 'Autre forfait',
  }),
}

export const getServiceProvisionTypeLabel = (
  type: ServiceProvisionTypeEnum,
  intl: IntlShape,
  serviceProviderCategory?: ServiceProviderCategoryEnum,
): string | undefined => {
  if (
    type === ServiceProvisionTypeEnum.OTHER &&
    serviceProviderCategory !== ServiceProviderCategoryEnum.BATCH_PROVISIONS
  ) {
    return 'Autre'
  }

  let label: MessageDescriptor | undefined = undefined

  switch (serviceProviderCategory) {
    case ServiceProviderCategoryEnum.RESTAURATION:
      label =
        serviceProvisionRestaurationLabels[
          type as unknown as ServiceProvisionRestaurationTypeEnum
        ]
      break
    case ServiceProviderCategoryEnum.ACTIVITY:
      label =
        serviceProvisionActivityLabels[
          type as unknown as ServiceProvisionActivityTypeEnum
        ]
      break
    case ServiceProviderCategoryEnum.TRANSPORT:
      label =
        serviceProvisionTransportLabels[
          type as unknown as ServiceProvisionTransportTypeEnum
        ]
      break
    case ServiceProviderCategoryEnum.HOUSE:
      label =
        serviceProvisionHouseLabels[
          type as unknown as ServiceProvisionHouseTypeEnum
        ]
      break
    case ServiceProviderCategoryEnum.BATCH_PROVISIONS:
      label =
        serviceProvisionBatchProvisionsLabels[
          type as unknown as ServiceProvisionBatchProvisionTypeEnum
        ]
  }

  return label ? intl.formatMessage(label) : undefined
}
